
import { useState, useMemo, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { useProductsContext } from "../context/ProductsProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseChimney, faHeart, faList, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import logo from "../images/Screenshot_2.png";
import "../App.css";

const LogIn = () => {
  const { login, currentUser } = useAuthContext();
  return (
    !currentUser && (
      <button type="button" className="btn btn-warning" onClick={login}>
        Login
      </button>
    )
  );
};

const LogOut = () => {
  const { logout, currentUser } = useAuthContext();
  return (
    !!currentUser && (
      <button type="button" className="btn btn-danger" onClick={logout}>
        Logout
      </button>
    )
  );
};

function Navigation() {
  const { currentUser } = useAuthContext();
  const { pathname } = useLocation();

  const isAdmin =
    currentUser && currentUser.uid === "MlSWWW3AN0abFD4WFBQvhaSMtD42" || currentUser && currentUser.uid === "iHluN7su2ygsYZww7yqpNMtp6Bu2" || currentUser && currentUser.uid === "qwRS6DUA77bTheih6oozDV1k1O62";
    
  const username = useMemo(() => {
    return currentUser?.displayName || "Profile";
  }, [currentUser]);

  const avatar = useMemo(() => {
    return !!currentUser ? (
      <img
        className="avatar"
        src={currentUser?.photoURL}
        alt={currentUser?.displayName}
        width="30"
        height="30"
      />
      ) : (
        "Login"
      );
    }, [currentUser]);

  return (
    <ul className="nav-container">
      {currentUser && (
        <li className="nav-item nav_item">
          <Link
            className={`nav-link ${pathname === "/stockimages" ? "active" : ""}`}
            aria-current="page"
            to="/stockimages"
          >
            <FontAwesomeIcon icon={faHeart} style={{ width: "20px", height: "20px" }} /> Liked
          </Link>
        </li>
      )}

      <li className="nav-item nav_item">
        <Link
          className={`nav-link ${pathname === "/" ? "active" : ""}`}
          aria-current="page"
          to="/"
        >
          <FontAwesomeIcon icon={faHouseChimney} style={{ width: "20px", height: "20px" }} /> Home
        </Link>
      </li>

      <li className="nav-item dropdown nav_item">
        <Link
          className="nav-link"
          to="#"
          id="navbarDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {avatar}
        </Link>
        <ul
          className="dropdown-menu dropdown_login"
          aria-labelledby="navbarDropdown"
        >
          {currentUser && (
            <li>
                <Link className="dropdown-item text-center" to="/profile">{username}</Link>
            </li>
          )}
          {isAdmin && (
            <li>
                <Link className="dropdown-item text-center" to="/get-all-items">Admin</Link>
            </li>
          )}
          <div className="d-flex justify-content-center">
            <LogIn />
            <LogOut />
          </div>
        </ul>
      </li>

    </ul>
  );
}

function SearchForm() {
  const { pathname } = useLocation();
  const [text, search] = useState(null);
  const { filterItems: filter } = useProductsContext();

  const handleOnChange = (e) => {
    const searchText = e.target.value;
    search(searchText);
    filter(searchText); // Search as the user types
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (text && text.trim() !== "") {
      filter(text.trim());
    } else {
      console.warn("Empty search input. Please enter a search term.");
      // You might want to handle the empty input case differently here
    }
  };

  return (
    pathname !== "/" && (
      <div className="search-container">
        <li className="nav-item dropdown nav_item">
        <Link
          className="nav-link  dropdown-toggle"
          to="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <FontAwesomeIcon icon={faList} style={{ width: "20px", height: "20px" }} />
        </Link>
        <ul className="dropdown-menu dropdown_menu">
          <li className="nav-item dropend">
            <Link
              className={`nav-link dropdown-toggle for_men ${
                pathname.includes("/categoryForMen") ? "active" : ""
              }`}
              to="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Accessories
            </Link>
            <ul className="dropdown-menu " >
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/jewellery" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/jewellery"
                >
                  Jewellery
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/glasses" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/glasses"
                >
                  Glasses
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/watches" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/watches"
                >
                  Watches
                </Link>
              </li>
            </ul>
          </li>
          <li className="nav-item dropend">
            <Link
              className={`nav-link dropdown-toggle for_women ${
                pathname.includes("/categoryForWomen") ? "active" : ""
              }`}
              to="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              For Women
            </Link>
            <ul className="dropdown-menu">
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/shoesProductsForWomen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/shoesProductsForWomen"
                >
                  Shoes
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/walletsProductsForWomen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/walletsProductsForWomen"
                >
                  Wallets
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/bagsforwomen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/bagsforwomen"
                >
                  Bags
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/clothesproductsforwomen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/clothesproductsforwomen"
                >
                  Clothes
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/perfumesforwomen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/perfumesforwomen"
                >
                  Perfumes
                </Link>
              </li>
            </ul>
          </li>
          <li className="nav-item dropend">
            <Link
              className={`nav-link dropdown-toggle for_men ${
                pathname.includes("/categoryForMen") ? "active" : ""
              }`}
              to="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              For Men
            </Link>
            <ul className="dropdown-menu " >
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/shoesProductsForMen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/shoesProductsForMen"
                >
                  Shoes
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/walletsProductsForMen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/walletsProductsForMen"
                >
                  Wallets
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/bagsformen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/bagsformen"
                >
                  Bags
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/clothesproductsformen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/clothesproductsformen"
                >
                  Clothes
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  className={`nav-link ${
                    pathname === "/perfumesformen" ? "active" : ""
                  }`}
                  aria-current="page"
                  to="/perfumesformen"
                >
                  Perfumes
                </Link>
              </li>
            </ul>
          </li>
        </ul>
        </li>
        <form className="form_container" onSubmit={handleOnSubmit}>
          <input
            onChange={handleOnChange}
            className="form-control search-input  form_control"
            type="search"
            placeholder="search here..."
            aria-label="Search"
          />
          <FontAwesomeIcon
              className="searchBtn"
              icon={faMagnifyingGlass}
              aria-hidden="true"
          />
        </form>
      </div>
    )
  )
}

export function SearchHome() {
  const { pathname } = useLocation();
  const [text, search] = useState("");
  const { filterItems: filter, state } = useProductsContext();
  const { items } = state;

  const navigate = useNavigate();
  const handleOnClick = (id) => {
    navigate(`/product/${id}`, { state: { id } });
    search("");
  };
  
  const handleOnClickCategory = useCallback(
    (item) => {
      switch (item.category) {
        case "Shoes":
          navigate(item.gender === "Men" ? "/shoesProductsForMen" : "/shoesProductsForWomen");
          break;
        case "Wallet":
          navigate(item.gender === "Men" ? "/walletsProductsForMen" : "/walletsProductsForWomen");
          break;
        case "Clothes":
          navigate(item.gender === "Men" ? "/clothesproductsformen" : "/clothesproductsforwomen");
          break;
        case "Perfumes":
          navigate(item.gender === "Men" ? "/perfumesformen" : "/perfumesforwomen");
          break;
        case "Bags":
          navigate(item.gender === "Men" ? "/bagsformen" : "/bagsforwomen");
          break;
        case "Watches":
          navigate("/watches");
          break;
        case "Jewellery":
          navigate("/jewellery");
          break;
        case "Glasses":
          navigate("/glasses");
          break;
        default:
          break;
      }
      search("");
    },
    [navigate, search]
  );

  const handleOnClickGender = useCallback(
    (item) => {
      switch (item.gender) {
        case "Men":
          navigate("/products-men");
          break;
        case "Women":
          navigate("/products-women");
          break;
        case "unisex":
          navigate("/categoryUnisex");
          break;
        default:
          break;
      }
      search("");
    },
    [navigate, search]
  );
  

  const handleOnChange = (e) => {
    const searchText = e.target.value;
    search(searchText || "");
    filter(searchText || ""); // Search as the user types
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (text && text.trim() !== "") {
      filter(text.trim());
    } else {
      console.warn("Empty search input. Please enter a search term.");
      // You might want to handle the empty input case differently here
    }
  };

  return (
    <div className="search-container2">
      <ul className="dropdown_category_container">
        <li className=" dropdown nav_item2">
          <Link
            className="nav-link  dropdown-toggle"
            to="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <FontAwesomeIcon icon={faList} style={{ width: "20px", height: "20px" }} />
          </Link>
          <ul className="dropdown-menu dropdown_menu">
            <li className="nav-item dropend">
              <Link
                className={`nav-link dropdown-toggle for_men ${
                  pathname.includes("/categoryForMen") ? "active" : ""
                }`}
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Accessories
              </Link>
              <ul className="dropdown-menu " >
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/jewellery" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/jewellery"
                  >
                    Jewellery
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/glasses" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/glasses"
                  >
                    Glasses
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/watches" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/watches"
                  >
                    Watches
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropend">
              <Link
                className={`nav-link dropdown-toggle for_women ${
                  pathname.includes("/categoryForWomen") ? "active" : ""
                }`}
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                For Women
              </Link>
              <ul className="dropdown-menu">
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/shoesProductsForWomen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/shoesProductsForWomen"
                  >
                    Shoes
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/walletsProductsForWomen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/walletsProductsForWomen"
                  >
                    Wallets
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/bagsforwomen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/bagsforwomen"
                  >
                    Bags
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/clothesproductsforwomen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/clothesproductsforwomen"
                  >
                    Clothes
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/perfumesforwomen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/perfumesforwomen"
                  >
                    Perfumes
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropend">
              <Link
                className={`nav-link dropdown-toggle for_men ${
                  pathname.includes("/categoryForMen") ? "active" : ""
                }`}
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                For Men
              </Link>
              <ul className="dropdown-menu " >
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/shoesProductsForMen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/shoesProductsForMen"
                  >
                    Shoes
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/walletsProductsForMen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/walletsProductsForMen"
                  >
                    Wallets
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/bagsformen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/bagsformen"
                  >
                    Bags
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/clothesproductsformen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/clothesproductsformen"
                  >
                    Clothes
                  </Link>
                </li>
                <li className="dropdown-item">
                  <Link
                    className={`nav-link ${
                      pathname === "/perfumesformen" ? "active" : ""
                    }`}
                    aria-current="page"
                    to="/perfumesformen"
                  >
                    Perfumes
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <form className="search" onSubmit={handleOnSubmit}>
        <div className="searchInput2">
          <input
            onChange={handleOnChange}
            className="form-control search-results form_control"
            type="search"
            placeholder="search here..."
            aria-label="Search"
          />
          <button type="submit" >
            {text.length === 0 ? <FontAwesomeIcon className="searchBtn"  icon={faMagnifyingGlass} aria-hidden="true" /> : ""}
          </button>
        </div>
        <div className="dataResultContainer">
        { text && (
          <div className="dataResult">
            {items.slice(0, 15).map((item) => (
              <div
                className="dataItem"
                key={item.id}
              >
                <img
                  src={item.path}
                  alt={item.title}
                  className="search-result-image"
                  onClick={() => handleOnClick(item.id)}
                />
                <br />
                <div className="search-result-text-container">
                  <span onClick={() => handleOnClick(item.id)} className="search-result-name">{item.title}</span>
                  <br />
                  <span onClick={() => handleOnClickCategory(item)}  className="search-result-options">go to {item.category} for {item.gender}</span>
                  <br />
                  <span  onClick={() => handleOnClickGender(item)} className="search-result-options">go to {item.gender} products</span>
                </div>
              </div>
            ))}
          </div>
        )}
        </div>
      </form>
    </div>
)
}

function Navbar() {
  return (
    <>
    <nav
      className="navbar navbar-expand-lg"
      
    >
      <div className="container-fluid">
      <Link to="/" className="navbar-brand fw-bold">
            <img style={{width: "68px", height: "34px"}} src={logo} alt="logo" />
          </Link>
        <div className="nav-container"  id="navbarSupportedContent">
          <Navigation />
        </div>
      </div>
      
      <div className="container-fluid">
      <SearchHome />
      </div>
    </nav>
    </>
  );
}
export default Navbar;
